document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.afdelingen_tabs-layout").forEach((layout) => {
        const tabs = [...layout.querySelectorAll(".afdeling-tab")];
        const stacked = window.matchMedia("(max-width: 992px)");
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
        if (!tabs.length) return;

        const select = (index, { focus = false, reveal = false } = {}) => {
            tabs.forEach((tab, i) => {
                const isActive = i === index;
                const panel = layout.querySelector(`#${tab.getAttribute("aria-controls")}`);

                tab.setAttribute("aria-selected", String(isActive));
                tab.tabIndex = isActive ? 0 : -1;
                if (panel) panel.hidden = !isActive;

                if (isActive && focus) tab.focus();
                if (isActive && reveal && panel && stacked.matches) {
                    panel.scrollIntoView({ behavior: reduceMotion.matches ? "auto" : "smooth", block: "nearest" });
                }
            });
        };

        tabs.forEach((tab, index) => {
            tab.addEventListener("click", () => select(index, { reveal: true }));

            tab.addEventListener("keydown", (event) => {
                const keys = {
                    ArrowDown: (index + 1) % tabs.length,
                    ArrowRight: (index + 1) % tabs.length,
                    ArrowUp: (index - 1 + tabs.length) % tabs.length,
                    ArrowLeft: (index - 1 + tabs.length) % tabs.length,
                    Home: 0,
                    End: tabs.length - 1,
                };
                if (!(event.key in keys)) return;

                event.preventDefault();
                select(keys[event.key], { focus: true });
            });
        });
    });
});
